module.exports = __webpack_public_path__ + "img/matjek.5ccc6c2f.png";